export const SiteStorageKeys = {
	siteLanguageKey: 'siteLanguageKey',
	localTokenKey: 'htcrm-localToken'
};
